export interface IUserflowConfiguration {
    environmentKey?: string;
    contentId?: string;
}
